import React, {useState} from "react";
import {InfoWindow, Marker} from "react-google-maps";


const Point = ({data}) => {
    const [isShowing, setIsShowing] = useState(false);
    const lat = data.geometry.coordinates[1];
    const lng = data.geometry.coordinates[0];
    const name = data.properties.name;
    const address = data.properties.address;
    return (
        <Marker position={{lat, lng}} onClick={() => setIsShowing(true)}>
            {isShowing &&
            <InfoWindow onCloseClick={() => setIsShowing(false)}><h4>{name}<br/>{address}</h4></InfoWindow>}
        </Marker>
    );
};

export default Point;